import { UserI } from './user';
import { CustomerI } from './customer';

export interface BodyMeasurementI {
  id: string;
  userid: string;
  // bodymeasurements_details: BodyFatTestI
  emailAddress?: string;
  user: UserI;
  // id?: string;
  // testDate?: string;
  // phoneNumber?: string;
  // emailAddress?: string;
  // age?: number;
  // gender?: string;
  // // weight?: number;//POSSIBLE DUPLICATE
  // dryWeight?: number; //POSSIBLE DUPLICATE
  // height?: number;
  // salinity?: string;
  // waterTemperature?: number; //
  // wetWeightKg?: number;
  // residualLungValue?: number;
  // fatLbs?: number;
  // fatPercent?: number; //POSSIBLE DUPLICATE
  // // bodyFatPercent?: number;//POSSIBLE DUPLICATE
  // leanLbs?: number;
  // leanMassPercent?: number;
  // waterLbs?: number; //POSSIBLE DUPLICATE
  // // wetWeight?: number;//POSSIBLE DUPLICATE
  // restingMetabolicRate?: number;
  // isTraining?: boolean;
  // bodyFatTestForCustomerId?: string | null;
  // bodyFatTestSavedInProfileId?: string | null;
  // bodyFatTestEventClubId?: string | null;
  // bodyFatTestEventOperatorId?: string | null;
  // bodyFatTestEventAssignedTruckId?: string | null;
  // bodyFatTestNote?: string | null;
  // bodyFatTestNoteId?: string | null;
  // bodyFatTestCompletedSurveyTDEEId?: string | null;
  // bodyFatTestCompletedSurveyMACROSId?: string | null;
  // bodyFatMeasureTestOrderId?: string | null;
  // bodyFatTestPaymentDetailId?: string | null;
  // currentStep?: string | null;
  // isExistingUser?: boolean; // if users have uid
  // isTestCompleted?: boolean;
  // createdAt?: string;
  // updatedAt?: string;
}

export interface BodyFatTestI {
  assignedTruck?: string;
  assignedEvent?: string;
  assignedOperator?: string;
  assignedEventClub?: string;
  assignedClub?: string;
  assignedCheckinSessionId?: string;
  bodyFatTestForCustomer?: ClientDetails;
  customerId?: string;
  testDetails?: TestData;
  // id: string;
  userid?: string;
  // bodymeasurements_details: BodyFatTestI
  emailAddress?: string;
  /** Customer email surfaced on admin Reports list rows (#2297). PII — mask before rendering. */
  customerEmail?: string;
  user?: UserI;

  id?: string;
  bodyFatMeasureTestReportId?: string;
  ethnicity?: string;
  birthDate?: string;

  age?: number;

  createdAt?: string;
  dryWeight?: string | number;
  v02MaX?: string | number;
  fatLbs?: number;
  fatPercent?: string | number;
  sex?: string;
  gender?: string;
  height?: number;
  isTraining?: boolean;
  leanLbs?: number;
  leanMassPercent?: number;
  waterMassPercent?: number;
  note?: null;
  residualLungValue?: number;
  restingMetabolicRate?: number;
  salinity?: string;
  testDate?: string;
  testTime?: string;
  uid?: null;
  updatedAt?: string;
  // user_bodymeasurements_details_id?: string;
  waterLbs?: number;
  waterTemperature?: number;
  wetKg?: number;

  // testDate?: string;
  phoneNumber?: string;
  // emailAddress?: string;
  // age?: number;
  // gender?: string;
  // weight?: number;//POSSIBLE DUPLICATE
  // dryWeight?: number; //POSSIBLE DUPLICATE
  // height?: number;
  // salinity?: string;
  // waterTemperature?: number; //
  wetWeightKg?: number;
  // residualLungValue?: number;
  // fatLbs?: number;
  // fatPercent?: number; //POSSIBLE DUPLICATE
  // bodyFatPercent?: number;//POSSIBLE DUPLICATE
  // leanLbs?: number;
  // leanMassPercent?: number;
  // waterLbs?: number; //POSSIBLE DUPLICATE
  // wetWeight?: number;//POSSIBLE DUPLICATE
  // restingMetabolicRate?: number;
  // isTraining?: boolean;
  bodyFatTestForCustomerId?: string | null;
  bodyFatTestSavedInProfileId?: string | null;
  bodyFatTestEventClubId?: string | null;
  bodyFatTestEventOperatorId?: string | null;
  bodyFatTestEventAssignedTruckId?: string | null;
  bodyFatTestNote?: string | null;
  bodyFatTestNoteId?: string | null;
  bodyFatTestCompletedSurveyTDEEId?: string | null;
  bodyFatTestCompletedSurveyMACROSId?: string | null;
  bodyFatMeasureTestOrderId?: string | null;
  bodyFatTestPaymentDetailId?: string | null;
  currentStep?: string | null;
  isExistingUser?: boolean; // if users have uid
  isTestCompleted?: boolean;
  // createdAt?: string;
  // updatedAt?: string;
  // id: string;
  // userid: string;

  // id?: string;
  // testDate?: string;
  // phoneNumber?: string;
  // emailAddress?: string;
  // age?: number;
  // gender?: string;
  // // weight?: number;//POSSIBLE DUPLICATE
  // dryWeight?: number; //POSSIBLE DUPLICATE
  // height?: number;
  // salinity?: string;
  // waterTemperature?: number; //
  // wetWeightKg?: number;
  // residualLungValue?: number;
  // fatLbs?: number;
  // fatPercent?: number; //POSSIBLE DUPLICATE
  // // bodyFatPercent?: number;//POSSIBLE DUPLICATE
  // leanLbs?: number;
  // leanMassPercent?: number;
  // waterLbs?: number; //POSSIBLE DUPLICATE
  // // wetWeight?: number;//POSSIBLE DUPLICATE
  // restingMetabolicRate?: number;
  // isTraining?: boolean;
  // bodyFatTestForCustomerId?: string | null;
  // bodyFatTestSavedInProfileId?: string | null;
  // bodyFatTestEventClubId?: string | null;
  // bodyFatTestEventOperatorId?: string | null;
  // bodyFatTestEventAssignedTruckId?: string | null;
  // bodyFatTestNote?: string | null;
  // bodyFatTestNoteId?: string | null;
  // bodyFatTestCompletedSurveyTDEEId?: string | null;
  // bodyFatTestCompletedSurveyMACROSId?: string | null;
  // bodyFatMeasureTestOrderId?: string | null;
  // bodyFatTestPaymentDetailId?: string | null;
  // currentStep?: string | null;
  // isExistingUser?: boolean; // if users have uid
  // isTestCompleted?: boolean;
  // createdAt?: string;
  // updatedAt?: string;
}

export interface BodyFatTestReportI {
  id: string;
  customer: BodyFatTestForCustomerI;
  report: BodyFatReportI;
  bodyFatMeasureTestReportId: string;
}
export interface BodyFatReportI {
  id: string;
  testDate?: string;
  status?: string;
  createdAt?: string;
  updatedAt?: string;
  bodyFatTestSessionTestId?: string;
  testDetails: BodyFatTestDetails;
}

export interface BodyFatTestDetails {
  id: string;
  dryWeight?: number;
  height?: number;
  wetKg?: number;
  age?: number;
  sex?: string;
  gender?: string;
  salinity?: number;
  waterTemperature?: number;
  waterMassPercent?: number;
  residualLungValue?: number;
  fatLbs?: number;
  fatPercent?: number;
  leanLbs?: number;
  leanMassPercent?: number;
  waterLbs?: number;
  restingMetabolicRate?: number;
  createdAt?: string;
  updatedAt?: string;
  bodyFatMeasureTestSessionCheckInId?: string;
  bodyFatMeasureTestSessionCheckIn: BodyFatMeasureTestSessionCheckInI;
}
export interface BodyFatMeasureTestSessionCheckInI {
  bodyFatTestForCustomer: BodyFatTestForCustomerI;
  bodyFatMeasureTestSessionSetup: BodyFatMeasureTestSessionSetupI;
}

export interface BodyFatMeasureTestSessionSetupI {
  bodyFatTestEvent: BodyFatTestEventI;
  bodyFatTestEventOperator: BodyFatTestEventOperatorI;
  bodyFatTestEventAssignedTruck: BodyFatTestEventAssignedTruckI;
}
export interface BodyFatTestEventAssignedTruckI {
  truckName: string;
}
export interface BodyFatTestEventOperatorI {
  operatorUserName: string;
}
export interface BodyFatTestEventI {
  testEventName: string;
}
export interface BodyFatTestForCustomerI {
  firstName: string;
  phoneNumber: string;
  emailAddress: string;
}
export interface BodyMeasurementReportI {
  id?: string;
  sessionDetails: {
    testDate?: string;
    testTime?: string;
    amountPaid?: number;
    operatorName: string;
    clubName: string;
    truckName: string;
    bodyFatClubId?: string;
    bodyFatTestEventAssignedTruckId?: string;
    bodyFatTestEventClubId?: string;
    bodyFatTestEventOperatorId?: string;
    waterTemperature?: number;
    testData?: TestData;
  };

  clientDetails: ClientDetails;

  // phoneNumber?: string;
  // emailAddress?: string;
  // age?: number;
  // gender?: string;
  // // weight?: number;//POSSIBLE DUPLICATE
  // dryWeight?: number; //POSSIBLE DUPLICATE
  // height?: number;
  // salinity?: string;
  // waterTemperature?: number; //
  // wetWeightKg?: number;
  // residualLungValue?: number;
  // fatLbs?: number;
  // fatPercent?: number; //POSSIBLE DUPLICATE
  // // bodyFatPercent?: number;//POSSIBLE DUPLICATE
  // leanLbs?: number;
  // leanMassPercent?: number;
  // waterLbs?: number; //POSSIBLE DUPLICATE
  // // wetWeight?: number;//POSSIBLE DUPLICATE
  // restingMetabolicRate?: number;
  // isTraining?: boolean;

  clientHistory: ClientHistory[];

  // bodyFatTestForCustomerId?: string | null;
  // bodyFatTestSavedInProfileId?: string | null;
  // bodyFatTestEventClubId?: string | null;
  // bodyFatTestEventOperatorId?: string | null;
  // bodyFatTestEventAssignedTruckId?: string | null;
  // bodyFatTestNote?: string | null;
  // bodyFatTestNoteId?: string | null;
  // bodyFatTestCompletedSurveyTDEEId?: string | null;
  // bodyFatTestCompletedSurveyMACROSId?: string | null;
  // bodyFatMeasureTestOrderId?: string | null;
  // bodyFatTestPaymentDetailId?: string | null;
  // currentStep?: string | null;
  // isExistingUser?: boolean; // if users have uid
  // isTestCompleted?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface BodyFatTestRequest {
  dryWeight: number;
  height: number;
  wetWeight: number;
  waterTemperature: number;
  currentStep: string;
  isTestCompleted: boolean;
}
export interface BodyFatTestResponse {
  dryWeight: number;
  height: number;
  wetWeight: number;
  waterTemperature: number;
  fatLbs: number;
  fatPercent: number;
  leanLbs: number;
  leanMassPercent: number;
  waterLbs: number;
  restingMetabolicRate: number;
}

export interface ClientDetails {
  bodyFatTestForCustomerId?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  emailAddress?: string;
  phoneNumber?: string;
  height?: number;
  age?: number;
  gender?: string;
}

export interface TestData {
  id?: string;
  testDate?: string;
  height?: number;
  dryWeight?: number; //POSSIBLE DUPLICATE
  wetWeightKg?: number;
  fatLbs?: number;
  residualLungValue?: number;
  fatPercent?: number;
  restingMetabolicRate?: number;
  waterLbs?: number;
  leanMassPercent?: number;
  leanLbs?: number;
  wetKg?: number;
  fatPercentChange?: number;
  weightChange?: number;
  leanLbChange?: number;
  fatLbChange?: number;
  fatPercentDiff?: number;
}

export interface ClientHistory {
  id?: string;
  /**
   * Id of the completed report backing this row (#1023) — the `:reportId` for
   * `GET customer-portal/results/:reportId/pdf`. Absent on legacy/migrated rows
   * that never produced a completed report; the per-row download is hidden then.
   */
  reportId?: string;
  date: string;
  // age?: number;
  // salinity?: number;
  // sex?: string;
  // waterMassPercent?: number;
  // waterTemperature?: string;
  // gender?: string;
  // createdAt?: string
  // updatedAt?: string
  testDate?: Date | null;
  height?: number;
  dryWeight?: number | null; //POSSIBLE DUPLICATE
  wetWeightKg?: number | null;
  fatLbs?: string; // Override as string to match backend
  residualLungValue?: number | null;
  fatPercent?: string; // Override as string to match backend
  restingMetabolicRate?: number | null;
  waterLbs?: string; // Override as string to match backend
  leanMassPercent?: number | null;
  leanLbs?: string; // Override as string to match backend
  wetKg?: number | null;
  fatPercentChange?: number;
  weightChange?: number;
  leanLbChange?: number;
  fatLbChange?: number;
  fatPercentDiff?: string; // Should be string to match backend
  weightPercentDiff: string;
  leanLbsDiff: string;
  fatLbsDiff: string;
  bodyFatPercentDiff: string;
}

export interface TestSessionSetupI {
  id?: string;
  bodyFatTestEventClubId?: string;
  bodyFatTestEventOperatorId?: string;
  bodyFatTestEventAssignedTruckId?: string;
  waterTemperature?: number;
  status?: string;
  workFlowStep?: string;
}

/**
 * #615 scanner — what the operator scan endpoint resolves a signed QR into: the
 * customer to check in and the SPECIFIC booking the QR is a credential for (the
 * check-in create passes it on so a wrong-event QR is rejected, not silently
 * matched to a different booking).
 */
export interface QrScanResolvedI {
  customer: CustomerI;
  bookingId: string;
}

/**
 * #615 scanner — result of a successful auto check-in from a QR scan on the admin
 * check-in screen: the resolved customer plus the check-in row the operator
 * continues into start-test with. `alreadyCheckedIn` is true when the scan hit an
 * existing check-in (double scan) instead of creating a new one; `checkInStatus`
 * carries that row's lifecycle (`CHECKED_IN` / `TESTED` / `REPORTED`) so the UI
 * can tell a plain re-scan apart from a session whose test already finished.
 */
export interface QrScanCheckInResultI {
  customer: CustomerI;
  checkInId: string;
  alreadyCheckedIn: boolean;
  checkInStatus?: string;
}

export interface TestSessionCheckInI {
  id?: string;
  // bodyFatTestEventClubId?: string;
  bodyFatTestForCustomerId?: string;
  bodyFatMeasureTestSessionSetupId?: string;
  // waterTemperature?: number;
  status?: string;
  createdAt?: string;
  updatedAt?: string;
  // #615 scanner — true when the check-in endpoint found an existing check-in for
  // this session + customer and returned it instead of creating a duplicate row.
  alreadyCheckedIn?: boolean;
  // #615 scanner — request-side: the specific booking a scanned QR resolved to;
  // the backend gate then requires THAT booking to be the confirmed one for the
  // session's event (rejects wrong-event QRs). Absent on the manual flow.
  bookingId?: string;
  // id: 23085bcb-a7e3-4971-b399-716374691349,
  // firstName: Ricky,
  // lastName: Auer,
  // sex: FEMALE,
  // gender: Transexual man,
  // birthDate: 1968-05-12T06:20:47.353Z,
  // phoneNumber: 1-878-920-6090 x00657,
  // address1: 40775 Silas Ports,
  // address2: null,
  // city: Huelstown,
  // state: NE,
  // zipCode: 44375,
  // uid: null,
  // emailAddress: Clemmie_King90@hotmail.com,
  // age: 0,
  // isEmployee: false,
  // useSiri3: false,
  // isSiri3: false,
  // ethnicity: White,
  // race: null,
  // isAfricanAmerican: false,
  // customerTeamsId: null,
  // customerPreferredClubId: null,
  // createdAt: 2023-10-28T22:33:15.356Z,
  // updatedAt: 2023-10-28T22:33:15.356Z,
  // updateDate: null
}
export interface TestSessionTestStepI {
  id?: string;
  // bodyFatTestEventClubId?: string;
  testDate?: string;
  height?: number;
  dryWeight?: number; //POSSIBLE DUPLICATE
  wetWeightKg?: number;
  testSessionCheckInId?: string;
  // bodyFatMeasureTestSessionSetupId?: string;
  // waterTemperature?: number;
  status?: string;
  createdAt?: string;
  updatedAt?: string;
  // id: 23085bcb-a7e3-4971-b399-716374691349,
  // firstName: Ricky,
  // lastName: Auer,
  // sex: FEMALE,
  // gender: Transexual man,
  // birthDate: 1968-05-12T06:20:47.353Z,
  // phoneNumber: 1-878-920-6090 x00657,
  // address1: 40775 Silas Ports,
  // address2: null,
  // city: Huelstown,
  // state: NE,
  // zipCode: 44375,
  // uid: null,
  // emailAddress: Clemmie_King90@hotmail.com,
  // age: 0,
  // isEmployee: false,
  // useSiri3: false,
  // isSiri3: false,
  // ethnicity: White,
  // race: null,
  // isAfricanAmerican: false,
  // customerTeamsId: null,
  // customerPreferredClubId: null,
  // createdAt: 2023-10-28T22:33:15.356Z,
  // updatedAt: 2023-10-28T22:33:15.356Z,
  // updateDate: null
}
